import Link from "next/link";

import CentraImage from "@/components/CentraImage";
import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";

import styles from "./seriesCard.module.scss";

type Props = NonNullable<VariantPage["relatedSeries"]>[number] & {
  hovering: boolean;
  hover: () => void;
  unhover: () => void;
};

const UI = (props: Props) => {
  const { uri, name, media, hovering, hover, unhover } = props;
  return (
    <Link href={uri} legacyBehavior>
      <div
        className={styles.container}
        onMouseEnter={hover}
        onMouseLeave={unhover}
      >
        <figure className={styles.imageContainer}>
          {media[0] && (
            <div className={styles.image}>
              <CentraImage src={media[0].uri} alt={media[0].alt} />
            </div>
          )}
          {media[1] && (
            <div
              className={`${styles.image} ${styles.inUse} ${
                hovering ? styles.hovering : ""
              }`}
            >
              <CentraImage src={media[1].uri} alt={media[1].alt} />
            </div>
          )}
        </figure>
        <p className={styles.title}>{name}</p>
      </div>
    </Link>
  );
};

export default UI;
